import React, { useState } from "react";
import "./Footer.scss";
import CarouselFooter from "./CarouselFooter";
import { FaArrowRight, FaPlus, FaMinus } from "react-icons/fa6";
import sendEmail from "../../../../../utils/sendMail"; // new: import email sender

// Simple hook to detect mobile
function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 600);
  React.useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return isMobile;
}

const columns = [
  {
    title: "Our Socials",
    items: [
      { label: "TikTok", href: "https://www.tiktok.com/@_kejani.co.ke?_t=ZM-8yzPrAkPA18&_r=1" },
      { label: "Instagram", href: "https://www.instagram.com/_kejani.co.ke?igsh=MTFodnF5Y3htbWRucw==" },
      // { label: "LinkedIn", href: "#" },
      { label: "Facebook", href: "https://www.facebook.com/share/1CPb5P8dac/" },
    ],
  },
  {
    title: "Contacts",
    items: [
      { label: "rentlybuzz@gmail.com", href: "mailto:rentlybuzz@gmail.com" },
      { label: "+254 799966603", href: "tel:+254799966603" },
      { label: "Nairobi, Kenya", href: "#" },
    ],
  },
  {
    title: "Support",
    items: [
      { label: "Help Center", href: "#" },
      { label: "FAQs", href: "#" },
      { label: "Live Chat", href: "#" },
    ],
  },
];

export default function Footer() {
  const isMobile = useIsMobile();
  const [openIdx, setOpenIdx] = useState(null);
  // new: email input + sending/status state
  const [emailValue, setEmailValue] = useState("");
  const [sending, setSending] = useState(false);
  const [statusMsg, setStatusMsg] = useState("");

  // new: simple email validator
  const isValidEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const handleToggle = (idx) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  // new: submit handler sends the fixed message "I'm requesting help"
  const handleSubmit = async () => {
    if (!emailValue) {
      setStatusMsg("Please enter your email");
      return;
    }
    if (!isValidEmail(emailValue)) {
      setStatusMsg("Please enter a valid email address");
      return;
    }
    setSending(true);
    setStatusMsg("");
    try {
      await sendEmail({
        name: "Website Visitor",
        email: emailValue,
        message: "I'm requesting help",
      });
      setStatusMsg("Request sent. We will contact you shortly.");
      setEmailValue("");
    } catch (err) {
      console.error("sendEmail error:", err);
      setStatusMsg("Failed to send. Please try again later.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="footer-new">
      <CarouselFooter />
      <div className="bottom-section">
        <div className="left">
          <div className="text">Still have questions?</div>
          <div className="short-description">
            Whether you need tenant management, invoice scheduling, or robust
            accounting tools, Rentlybuzz centralizes everything landlords and
            property managers need.
          </div>
          <div className="email-container">
            <input
              type="email"
              placeholder="Enter your email"
              className="footer-email-input"
              value={emailValue}
              onChange={(e) => {
                setEmailValue(e.target.value);
                if (statusMsg) setStatusMsg("");
              }}
            />
            <div className="button-container">
              <button
                className="footer-email-btn"
                type="button"
                onClick={handleSubmit}
                disabled={sending}
              >
                {"Submit".split("").map((char, i) => (
                  <span className="hero-button-letter" key={i}>
                    {char === " " ? "\u00A0" : char}
                  </span>
                ))}
              </button>
              <button
                className="arrow"
                aria-hidden="true"
                type="button"
                onClick={handleSubmit}
                disabled={sending}
              >
                <span className="hero-button-letter">
                  <FaArrowRight />
                </span>
              </button>
            </div>
          </div>
          <div className="footer-status-container">
            {statusMsg && <div className="footer-status">{statusMsg}</div>}
          </div>
        </div>
        <div className="footer-divider"></div>
        <div className="right">
          <div className="footer-columns">
            {isMobile
              ? columns.map((col, idx) => (
                  <div className="footer-column mobile" key={col.title}>
                    <div
                      className="footer-column-row"
                      onClick={() => handleToggle(idx)}
                    >
                      <span className="footer-column-title">{col.title}</span>
                      <span className="footer-column-icon">
                        {openIdx === idx ? <FaMinus /> : <FaPlus />}
                      </span>
                    </div>
                    {/* Only show underline if not last item */}
                    {idx !== columns.length - 1 && (
                      <div className="footer-column-underline"></div>
                    )}
                    {openIdx === idx && (
                      <ul className="footer-column-dropdown">
                        {col.items.map((item) => (
                          <li key={item.label}>
                            <a href={item.href}>{item.label}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))
              : columns.map((col) => (
                  <div className="footer-column" key={col.title}>
                    <div className="footer-column-title">{col.title}</div>
                    <ul>
                      {col.items.map((item) => (
                        <li key={item.label}>
                          <a href={item.href}>{item.label}</a>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
          </div>
        </div>
      </div>
      {/* Thin bottom section */}
      <div className="footer-bottom-bar">
        <span>© 2025 by Rently | All rights reserved</span>
        <span className="footer-bottom-links">
          <a href="#" className="footer-bottom-link">
            Privacy Policy
          </a>
          {/* , Website by{" "}
          <a
            href="https://linkedin.com/in/timothy-ndiritu-61385b2a3"
            className="footer-bottom-author"
            target="_blank"
            rel="noopener noreferrer"
          >
            Timothy Ndiritu
          </a> */}
        </span>
      </div>
    </div>
  );
}
